const routes = [
  {
    path: '/relatorio/pontuacao',
    name: 'pontuacao',
    component: () => import('@/views/relatorio/equipe/PontuacaoPorEquipe.vue'),
    meta: { breadcrumb: [{ title: 'Relatórios' }, { title: ' Equipes' }, { title: 'Pontuação' }] },
  },
  {
    path: '/relatorio/produtividade',
    name: 'produtividade',
    component: () => import('@/views/relatorio/equipe/Produtividade.vue'),
    meta: { breadcrumb: [{ title: 'Relatórios' }, { title: ' Equipes' }, { title: 'Produtividade' }] },
  },
]

export default routes
